import React from "react";

import connect from "glassRedux/connect";

import { bindActionCreators } from "redux";

import {
  resolveTask,
  addEmptyDay,
  setNeedsScrollAlignment,
  setNeedsCursorAdjustment,
} from "shared/itemLists/redux/itemListsSlice";

import DimensionHelper from "./helpers/dimensionHelper"

export class CursorItemsCoordinator extends React.Component {
  constructor(props) {
    super(props);
    this.dimHelper = {}
    this.state = {
      cursorTop: 0,
      dateUpdated: false,
    };
    this.handleWheel = this.handleWheel.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  componentDidMount() {
    const {heightAndTimeArray, happyPlaceDistanceType} = this.props
    console.log('happyPlaceDistanceType in cdu: ', happyPlaceDistanceType);
    const clientHeight = this.props.getClientHeight()
    this.dimHelper = new DimensionHelper({heightAndTimeArray, clientHeight, happyPlaceDistanceType})
    this.setCursorTopByCursorIndex();
    window.addEventListener && window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount() {
    window.addEventListener && window.removeEventListener("resize", this.updateDimensions);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.needsScrollAlignment) {
      const nsa = this.props.needsScrollAlignment;
      if ("scrollTop" in nsa) {
        this.props.scrollContainerTo({
          top: nsa.scrollTop,
          behavior: "auto",
        });
      } else if (nsa.position === "auto") {
        const newCI = this.props.cursorIndex + (nsa.adjustIndex || 0);
        const newCT = this.getCursorTop(newCI);
        this.adjustScrollFromCursor({
          newCursorTop: newCT,
          behavior: nsa.behavior,
        });
      }
      if (nsa.adjustIndex) {
        this.props.setCursorIndex((curr) => curr + nsa.adjustIndex);
      }
      this.props.setNeedsScrollAlignment(false);
    }

    if (this.props.needsCursorAdjustment) {
      this.adjustToCursorIndex(this.props.needsCursorAdjustment);
      this.props.setNeedsCursorAdjustment(null);
    }

    if (prevProps.heightAndTimeArray !== this.props.heightAndTimeArray) {
      this.updateItemDependentDimensions();
      this.setCursorTopByCursorIndex();
    }

    if (
      this.props.happyPlaceDistanceType !== prevProps.happyPlaceDistanceType
    ) {
      this.dimHelper.updateHPDistanceType(this.props.happyPlaceDistanceType)
      this.updateDimensions();
    }

    if (prevProps.cursorIndex !== this.props.cursorIndex) {
      if (!this.state.dateUpdated && !this.props.hasBlankTask) {
        console.log('this.props.cursorIndex in location: ', this.props.cursorIndex);
        this.adjustSelectedDate(this.props.cursorIndex);
      } else {
        this.setState({ dateUpdated: false });
      }
      const newCT = this.getCursorTop(this.props.cursorIndex);
      this.setState({ cursorTop: newCT });
    }
    if (
      this.props.isChangingDayFromNonScrollEvent &&
      this.props.addEmptyDaysOnClick &&
      prevProps.selectedDate !== this.props.selectedDate &&
      !this.props.isAddingTaskWithEnter
    ) {
      this.moveCursorWithEffects();
    }
  }

  async _removeEmptyDay() {
    if (this.props.hasEmptyDay) {
      this.props.removeEmptyDay({ method: "dayChange" });
      return true
    } else {
      return false
    }
  }

  async moveCursorWithEffects() {
    let ci = this.props.cursorIndex;
    let range = this.cursorIndexRange(this.props.selectedDate);
    this._needEmptyDay = this.needEmptyDay(range.min);
    if (this._needEmptyDay) {
      if(await this._removeEmptyDay()){
        ci = this.props.cursorIndex;
        range = this.cursorIndexRange(this.props.selectedDate);
      }
      this.props.addEmptyDay({ selectedDate: this.props.selectedDate });
    }
    if (ci < range.min || ci > range.max || this._needEmptyDay) {
      const needEmptyDayIncr = this._needEmptyDay;
      const newCI = range.min + (needEmptyDayIncr ? 1 : 0);
      this.setState({
        dateUpdated: true,
      });
      this.adjustToCursorIndex({ cursorIndex: newCI });
    }
  }

  updateItemDependentDimensions() {
    this.dimHelper.updateHeightAndTimeArray(this.props.heightAndTimeArray)
  }

  updateDimensions() {
    this.dimHelper.updateClientHeight(this.props.getClientHeight())
  }

  adjustToCursorIndex({ cursorIndex, behavior }) {
    const newCT = this.getCursorTop(cursorIndex);
    this.props.setCursorIndex(cursorIndex);
    this.adjustScrollFromCursor({ newCursorTop: newCT, behavior });
    this.setState({ cursorTop: newCT });
  }

  setCursorTopByCursorIndex() { // web only, though unecessarily called in both
    const height =
      this.props.heightAndTimeArray[this.props.cursorIndex] &&
      this.props.heightAndTimeArray[this.props.cursorIndex].height;
    this.setState({
      cursorTop: height,
    });
  }

  handleWheel(provided) {
    this.props.resolveTask({ method: "scroll" });
    const latestScrollTop = this.props.getContainerScrollTop();
    const nearestIndex = this.nearestItemIndex(
      latestScrollTop + this.spaceBetweenScrollTopAndCursor({ latestScrollTop })
    );
    if (this.props.cursorIndex !== nearestIndex) {
      this.props.setCursorIndex(nearestIndex);
    }
  }

  nearestItemIndex(height, heights = this.props.heightAndTimeArray) {
    for (let i = 0; i < heights.length; i++) {
      let item = heights[i];
      if (item.height === height) {
        return i;
      } else if (item.height > height) {
        if (heights[i - 1] === undefined) {
          return i;
        }
        let currentDiff = item.height - height;
        let previousDiff = height - heights[i - 1].height;
        if (currentDiff > previousDiff) {
          return i - 1;
        } else {
          return i;
        }
      }
    }
    return heights.length - 1;
  }

  getCursorTop(cursorIndex) {
    return this.height(cursorIndex);
  }

  adjustSelectedDate(cursorIndex) {
    const item = this.props.heightAndTimeArray[cursorIndex];
    if (item) {
      const newDate = this.props.heightAndTimeArray[cursorIndex].day;
      if (newDate.getTime() !== this.props.selectedDate.getTime()) {
        this.props.setSelectedDate(newDate);
      }
    }
  }

  adjustScrollFromCursor({ newCursorTop, behavior }) {
    if (!behavior) behavior = "smooth";
    const newScrollTop = newCursorTop - this.spaceBetweenScrollTopAndCursor({newCursorTop});
    this.props.scrollContainerTo({
      left: 0,
      top: newScrollTop,
      behavior,
    });
  }

  spaceBetweenScrollTopAndCursor({ latestScrollTop, newCursorTop }) {
    if (latestScrollTop !== undefined) {
      return this.dimHelper.calcSpaceByScrollTop({latestScrollTop});
    } else {
      return this.dimHelper.calcSpaceByCursorTop({newCursorTop});
    }
  }

  cursorIndexRange(date) {
    let start = null;
    let end = null;
    const items = this.props.heightAndTimeArray;
    for (let i = 0; i < items.length; i++) {
      let item = items[i];

      if (item.day.getTime() > date.getTime()) {
        start = i - 1;
        end = i - 1;
        break;
      } else if (item.day.getTime() === date.getTime()) {
        start = i;
        for (let j = i; j < items.length; j++) {
          let endItem = items[j];
          if (
            endItem.day.getTime() > date.getTime() ||
            j === items.length - 1
          ) {
            end = j - 1;
            break;
          }
        }
        break;
      }
    }

    if (start !== null && end !== null) {
      return { min: start, max: end };
    } else {
      return { min: items.length - 1, max: items.length - 1 };
    }
  }

  height(cursorIndex) {
    const hat = this.props.heightAndTimeArray[cursorIndex];
    return hat ? hat.height : 0;
  }

  needEmptyDay(cursorIndex) {
    return (
      this.props.selectedDate.getTime() !==
      this.props.heightAndTimeArray[cursorIndex].day.getTime()
    );
  }

  render() {
    return (
      this.props.renderPlatformedCoordinator({
        cursorTop: this.state.cursorTop, //web only
        handleWheel: this.handleWheel, //web only
        scrollGutterHeight: this.dimHelper.scrollGutterHeight
      })
    );
  }
}

function mapStateToProps(state) {
  return {
    isChangingDayFromNonScrollEvent: state.itemLists.isChangingDayFromNonScrollEvent,
    isAddingTaskWithEnter: state.itemLists.insertStatus.isAddingTaskWithEnter,
    hasEmptyDay: state.itemLists.insertStatus.hasEmptyDay,
    hasBlankTask: state.itemLists.insertStatus.hasBlankTask,
    needsScrollAlignment: state.itemLists.insertStatus.needsScrollAlignment,
    needsCursorAdjustment: state.itemLists.needsCursorAdjustment,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      resolveTask,
      addEmptyDay,
      setNeedsScrollAlignment,
      setNeedsCursorAdjustment,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CursorItemsCoordinator);
